<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        支店管理 - 一括登録
        <div class="headerBtn" @click="branchList" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録準備
        </div>
        <div class="row" style="text-align: left;">
          最初に、以下のボタンより登録用のテンプレートファイルをダウンロードします。
        </div>
        <div class="row">
          <div class="edit" @click="doDownload(templateFilePath, templateFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            テンプレート
          </div>
          <div class="detail" @click="doDownload(sumpleFilePath, sumpleFileName)">
            <!--  DLアイコン設定予定 v-icon? -->
            記入サンプル
          </div>
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg">
        <div class="groupTitle" style="display: flex;">
          登録用テンプレート記載方法
        </div>
        <div class="row" style="text-align: left;">
          2行目以降に支店名、メールアドレス、パスワードをカンマ区切りで記載します。<br>
          空白や空行を含めますと正常に処理が終了しない可能性がございますので、加えないようお願い致します。<br>
          行の末尾にはカンマは不要です。<br>
          Excelなどで保存した場合、エラーとなる可能性がございますので、編集時には他のテキストツールをご利用下さい。
        </div>
        <div class="row">
          <img src="../assets/branch-bulk-sample.png">
        </div>
      </div>

      <div class="group" v-if="!getLodingFlg && !getErrorFlg && resultRows.length === 0">
        <div class="groupTitle" style="display: flex;">
          <!--  アップロードアイコン設定予定 v-icon? -->
          アップロード
        </div>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="row" style="text-align: left;">
            支店情報を記載し保存したファイルを以下で選択し、アップロードして下さい。
          </div>
          <div class="row">
            <div style="text-align: left">
            <validation-provider name="uploadFIleVal" rules="required|ext:csv">
              <div slot-scope="ProviderProps">
                <input type="file" ref="uploadFile" accept=".csv" @change="ProviderProps.validate($event); loadCsvFile($event)">
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
        </div>
          <div class="row" style="text-align: left;">
            選択されたファイル: {{fileName}} <br>
            対応するファイル形式　.csv/最大件数1000件
          </div>
          <div class="buttonGroup">
            <button class="btn" @click="csvExtract"
            v-bind:class="{
              disabled: ObserverProps.invalid || !ObserverProps.validate || !upFile || parseFlg,
              active: !ObserverProps.invalid && ObserverProps.validate && upFile && !parseFlg
            }"
            :disabled="ObserverProps.invalid || parseFlg"
            style="width: 400px;">アップロードして確認
            </button>
          </div>
        </validation-observer>
      </div>

      <!-- ローディング -->
      <div v-if="postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>

      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>

      <div v-if="rows.length > 0 && !postLodingFlg && resultRows.length === 0">
        <vue-good-table
          :columns='columns'
          :rows='rows'
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
          >
          <div slot="emptystate">データがありません</div>
        </vue-good-table>
        <div v-if="errorMessages.length > 0">
          <div　class="errMsg" v-for="error in errorMessages">
            <div class="errSpan">{{error}}</div>
          </div>
        </div>
        <div class="buttonGroup">
          <button class="btn" @click="confirm" style="width: 400px;"
          v-bind:class="{active: true}">登録</button>
        </div>
      </div>
      <div v-if="resultRows.length > 0">
        <vue-good-table
          :columns='resultColumns'
          :rows='resultRows'
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
          >
          <div slot="emptystate">データがありません</div>
        </vue-good-table>
        <div class="buttonGroup">
          <button type="button" class="csvBtn" @click="callOutputCsv()"
            v-bind:class="{ active: true}">
            登録結果をCSV形式でダウンロード
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider, ValidationObserver } from 'vee-validate';
import { VueGoodTable } from 'vue-good-table';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T,  R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T,  R>(val: T): ChainedWhen<T,  R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T,  A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T,  A>(fn()) : chain<T,  A>(val),
});
// when使用のための処理 ------ end

export default {
  title: '支店一括登録',
  name: 'branchBulkAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    VueLoading,
  },
  // setup() {
  // return {
  // },
  // },
  data() {
    return {
      // 所属事業者の設定に必要となるログイン事業者の内部ID
      companyId: '',
      // テンプレートファイルパス
      templateFilePath: '/files/branch-bulk-template.csv',
      // テンプレートファイルダウンロード時のファイル名
      templateFileName: 'branch-bulk-template.csv',
      // 記入サンプルファイルパス
      sumpleFilePath: '/files/branch-bulk-sample.csv',
      // 記入サンプルファイルダウンロード時のファイル名
      sumpleFileName: 'branch-bulk-sample.csv',
      // アップロードファイル
      fileName: '',
      upFile: '',
      csvData: {},
      errorMessages: [],
      num: '',
      columns:  [
        {
          label: '支店名',
          field: 'branchName',
        },
        {
          label: 'メールアドレス',
          field: 'email',
        },
        {
          label: 'パスワード',
          field: 'password',
        },
      ],
      rows: [],
      resultColumns:  [
        {
          label: '支店名',
          field: 'branchName',
        },
        {
          label: 'ログインID',
          field: 'loginId',
        },
        {
          label: 'メールアドレス',
          field: 'email',
        },
        {
          label: 'パスワード',
          field: 'password',
        },
      ],
      resultRows: [],
      // ローディング
      getLodingFlg: false,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ登録時ローディングフラグ
      postErrorFlg: false,  // データ登録時エラーフラグ
      parseFlg: false,
      errorMessage: '',
    };
  },
  async mounted() {
    try {
      this.getLodingFlg = true;
      // セッション情報からログイン事業者IDを取得
      this.companyId = this.$store.getters.session.companyId;
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // アップロードファイル取得
    loadCsvFile(event) {
      this.fileName = event.target.files[0].name;
      this.upFile = event.target.files[0];
      this.$refs.uploadFile.value = null;
      this.parseFlg = false;
    },
    // アップロードして確認ボタン押下時
    async csvExtract() {
      const errorMessages = new Array();
      let flg = false;
      try {
        // 抽出CSV配列とエラーメッセージ配列を空にする
        this.csvData.length = 0;
        if (!this.upFile) {
          errorMessages.push('ファイルを選択して下さい。');
          return;
        }
        // 取り込んだCSVファイルをオブジェクト配列に変換
        this.$papa.parse(this.upFile, {
          encoding: 'UTF-8',
          header: true,
          complete: this.csvGet,
          error: function(err, file) {
            errorMessages.push('CSVの抽出に失敗しました。ファイルを再度選択して下さい');
            flg = true;
          }
        });
      } catch (error) {
        errorMessages.push('CSVの抽出に失敗しました。ファイル内のデータをご確認下さい');
      } finally {
        this.errorMessages = errorMessages;
        new Promise<void>((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1);
        }).then(() => {
          this.parseFlg = flg;
          this.scrollBottom();
        });
      }
    },
    // CSVから抽出されたオブジェクト配列を加工
    async csvGet(results) {
      const errorMessages = new Array();
      // 事業者ID　completeの中では参照できないためローカルの変数に移す
      const selectedCompanies = this.selectedCompanies;
      const restResourceService = new ApiClient();
      this.csvData = results.data;
      if(this.csvData.length === 0) {
        errorMessages.push('登録データが存在しません。ファイル内のデータをご確認下さい。');
      }
      for (let i = 0; i < this.csvData.length;  i++) {
        // ログイン中の事業者の事業者IDをプロパティとして追加
        this.csvData[i].companyId = this.companyId;
        // 必要情報が欠けた行が存在した場合、エラーメッセージを詰める
        if (!this.csvData[i].branchName && !this.csvData[i].loginId && !this.csvData[i].email && !this.csvData[i].password) {
          errorMessages.push('必要な列情報がありません。フォーマットを確認して下さい。');
          break;
        }

        const branchName = common.trimSpace(this.csvData[i].branchName);
        await validate(branchName, 'required|max:255', {
          name: '支店名（branchName）',
          values: {
            branchName
          }
        }).then((result) => {
          if (!result.valid) {
            errorMessages.push((i + 1) + '行目' + result.errors[0]);
          }
        });

        const email = common.trimSpace(this.csvData[i].email);
        await validate(email, 'required|max:255|emailVaridate', {
          name: 'メールアドレス（email）',
          values: {
            email
          }
        }).then((result) => {
          if (!result.valid) {
            errorMessages.push((i + 1) + '行目' + result.errors[0]);
          }
        });

        const password = common.trimSpace(this.csvData[i].password);
        await validate(password, 'required|min:8|max:64|password', {
          name: 'パスワード（password）',
          values: {
            password
          }
        }).then((result) => {
          if (!result.valid) {
            errorMessages.push((i + 1) + '行目' + result.errors[0]);
          }
        });
      }
      // エラーメッセージが詰められていた場合、処理を中断する
      if (errorMessages.length !== 0) {
        this.errorMessages = errorMessages;
        this.scrollBottom();
        return;
      }
      this.rows = this.csvData;
      this.scrollBottom();
    },
    // DOM更新待機後スクロール
    async scrollBottom() {
      await this.$nextTick();
      common.scrollBottom();
    },
    // ナンバリング取得
    // TODO suzuno フロント側ではログインID生成不要
    async callGetNumbering() {
      const key = this.$store.getters.loginId;
      // 採番取API
      const restResourceService = new ApiClient();
      this.num = await restResourceService.getNumbering(key);
    },
    // ログインID重複チェック
    // TODO suzuno 不要
    async callGetLoginIdcheck() {
      const restResourceService = new ApiClient();
      for (let i = 0; i < this.csvData.length; i++) {
        const result = await restResourceService.getLoginIdcheck(this.csvData[i].loginId);
        if(result) {
          await this.callGetNumbering();
          const number =  (('00000' + this.num).slice(-5));
          this.csvData[i].loginId = this.$store.getters.loginId + number;
        }
      }
    },
    // ナンバリング更新
    async callUpdateNumbering() {
      const key = this.$store.getters.loginId;
      for (let i = 0; i < this.csvData.length; i++) {
        // 採番更新API
        const restResourceService = new ApiClient();
        await restResourceService.updateNumbering(key);
      }
    },
    // 登録ボタン押下時処理
    async confirm() {
      try {
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        this.errorMessages = [];
        // TODO　一括登録画面ではログインIDの発行はバックエンドで行うため、フロント側での整形は不要
        // await this.callGetNumbering();
        // for (let i = 0; i < this.csvData.length; i++) {
        //   const num = this.num + i;
        //   const number =  (('00000' + num).slice(-5));
        //   this.csvData[i].loginId = this.$store.getters.loginId + number;
        // }
        // 採番重複チェック
        // await this.callGetLoginIdcheck();
        // 支店一括登録API呼出
        const restResourceService = new ApiClient();
        this.resultRows = await restResourceService.postBranch(this.csvData);
        for (let i = 0; i < this.resultRows.length; i++) {
          this.resultRows[i].password = this.rows[i].password;
        }
        const csv = this.callCognitoCsv();

        // uplord用URLの取得API呼出
        const urlBody = {
           accountType: 'branch',
           fileName: csv.name,
        };
        // TODO: 変更後に対応しているか要確認
        const uploadUrl = await restResourceService.postAccountsUploadUrl(urlBody)

        // リクエストボディに不要な要素を削除
        for (let i = 0; i < this.resultRows.length;  i++) {
          delete this.resultRows[i].createdAt;
        }
        // cognito一括登録実行
        fetch(uploadUrl.uploadUrl, {
          method: 'PUT',
          mode: "cors",
          headers: {
              'Content-Type': 'text/csv',
          },
          body: csv.body,
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.log(error);

        this.errorMessages[0] = error.message;
        this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
        await this.$nextTick();
        common.scrollBottom();
      }
    },
    // 支店一覧画面へ戻る
    branchList() {
      history.back();
    },
    // ダウンロード処理（ファイルパス, DL時ファイル名）
    doDownload(url, filename) {
      common.doDownload(url, filename);
    },
    // CSV出力用共通関数呼出
    callOutputCsv() {
      const today = common.getToday();
      const fileName = 'branch-bulk' + today;
      common.outputCsv(this.resultColumns, this.resultRows, fileName);
    },
    // CSV出力用共通関数呼出
    callCognitoCsv() {
      const today = common.getToday();
      const fileName = this.upFile.name;
      return common.cognitoCsv(this.resultColumns, this.resultRows, fileName);
    },
  },
}
;
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

/*** iOS ***/
.switch__label {
	width: 100px;
	position: relative;
	display: inline-block;
  margin-top: 13px;
}
.switch__content {
	display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
overflow: hidden;
}
.switch__content:before {
	content: "";
	display: block;
	position: absolute;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	top: 0;
	left: 0;
	border: 1.5px solid #E5E5EA;
	border-radius: 130px;
	background-color: #fff;
}
.switch__content:after {
	content: "";
	display: block;
	position: absolute;
	background-color: transparent;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	border-radius: 30px;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input {
	display: none;
}

.switch__circle {
	display: block;
	top: 2px;
	left: 2px;
	position: absolute;
	-webkit-box-shadow: 0 2px 6px #999;
	        box-shadow: 0 2px 6px #999;
	width: 27px;
	height: 27px;
	-webkit-border-radius: 20px;
	        border-radius: 20px;
	background-color: #fff;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input:checked ~ .switch__circle {
	left: 71px;
}

.switch__input:checked ~ .switch__content:after {
	background-color: #4BD964;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
